import { Button, Notification } from '@onbeam/ui';
import { hstack, text } from '@onbeam/styled-system/patterns';
import { css } from '@onbeam/styled-system/css';
import { useCookieConsentStore, useIsMounted } from '@onbeam/utils';
import { createPortal } from 'react-dom';
import { CookieConsentProps } from './CookieConsent.types';

export const CookieConsentPopup = ({
  consentDomain,
  i18n = {},
}: CookieConsentProps) => {
  const isMounted = useIsMounted();

  const { isConsentPopupOpen, openConsentModal, updateConsent } =
    useCookieConsentStore();

  const handleSetAll = (value: boolean) =>
    updateConsent(
      {
        ad_personalization: value,
        ad_storage: value,
        ad_user_data: value,
        analytics_storage: value,
        functionality_storage: true,
      },
      consentDomain,
    );

  if (!isMounted || !isConsentPopupOpen) return null;

  return createPortal(
    <div
      className={css({
        pos: 'fixed',
        zIndex: 40,
        bottom: '0',
        left: '0',
        px: { base: '3', sm: '6' },
        pb: { base: '3', sm: '6' },
        transform: 'translateY(100%)',
        animation: 'slideUp 0.5s 2s forwards',
      })}
      data-testid="cookie-consent-popup"
    >
      <Notification
        className={css({ w: { base: 'full', sm: '[22rem]' }, maxW: '[26rem]' })}
      >
        <p>{i18n.title}</p>
        <p
          className={text({
            style: 'sm',
            color: 'mono.300',
            mt: '1.5',
            mb: '2.5',
          })}
        >
          {i18n.description}
        </p>
        <div className={hstack({ gap: '1.5' })}>
          <Button
            variant="primary"
            size="sm"
            onClick={() => handleSetAll(true)}
          >
            {i18n.acceptLabel}
          </Button>
          <Button variant="secondary" size="sm" onClick={openConsentModal}>
            {i18n.manageLabel}
          </Button>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => handleSetAll(false)}
          >
            {i18n.rejectLabel}
          </Button>
        </div>
      </Notification>
    </div>,
    document.body,
  );
};
